import React from 'react'
import './ScreenLoader.scss'
import { ProgressSpinner } from 'primereact/progressspinner'
export default function ScreenLoader({ visible }) {
    return (
        visible ? (<div className="screen-loader">
            <ProgressSpinner />
        </div>) : ""

    )
}

export  function ScreenLoader2({ visible }) {
    return (
        visible ? (<div className="screen-loader">
            <ProgressSpinner />
        </div>) : ""

    )
}
